**Deprecated:** Use `issued` instead.
